import React from "react";
import {  Grid  } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { useSelector } from "react-redux";
import SearchableDropdown from "../../searchableDropdown";
import { selectQualifierList,selectGoodsLocationType } from "../../selectors";

export const GoodLocationForm=React.memo(({onChange,onSelect,onBlur,dataSource:{type,qualifierId,authorisationNumber,additionalIdentifier,latitude,longitude,unlocode}})=>{
  const goodsLocationTypeList=useSelector(selectGoodsLocationType)
  const qualifierList=useSelector(selectQualifierList)
 return (
    
         <Grid.Row>
          <Grid.Column>
            <DropDown
              id="locationOfGoods.type"
              label="TYPE"
              clearable
              name="type"
              labelClass="text-none"
              data={goodsLocationTypeList}
              value={type}
              text={type}
              onChange={onSelect}
            />
        
          </Grid.Column>
          <Grid.Column>
          <DropDown
            id="locationOfGoods.qualifierId"
            label="QUALIFIER_ID"
            clearable
            name="qualifierId"
            labelClass="text-none"
            data={qualifierList}
            value={qualifierId}
            text={qualifierId}
            onChange={onSelect}
          
        />
          </Grid.Column>
       
             <Grid.Column>
              <SearchableDropdown
                id="locationOfGoods.authorisationNumber"
                label="AUTH_NUMBER"
                name="authorisationNumber"
                dropdownType="authNumber"
                selectedValue={authorisationNumber}
                onSelect={({ value }) => onSelect(null,{value,name:"authorisationNumber"})}
                onBlur={({value})=>{
                  if(!value){
                    onSelect(null,{value,name:"authorisationNumber"})
                  }
              }}
          
        /> 
          </Grid.Column>
          <Grid.Column>
             <InputField
             id="locationOfGoods.additionalIdentifier"
              type='text'
              name="additionalIdentifier"
              value={additionalIdentifier}
              label="AUTH_IDENTIFIER"
              clearInput={false}
              onChange={onChange}
              onBlur={onBlur}
              />
          </Grid.Column>
          <Grid.Column>
          <InputField
            id="locationOfGoods.longitude"
              type='number'
              name="longitude"
              value={longitude}
              label="LONGITUDE"
              clearInput={false}
              onChange={onChange}
              onBlur={onBlur}
              />
              </Grid.Column>
              <Grid.Column>
              <InputField
              id="locationOfGoods.latitude"
              type='number'
              name="latitude"
              value={latitude}
              label="LATITUDE"
              clearInput={false}
              onChange={onChange}
              onBlur={onBlur}
             
              />
          </Grid.Column>
          <Grid.Column>
          <SearchableDropdown
           id="locationOfGoods.unLoc"
          label="UNLOC"
          name="unlocode"
          dropdownType="unlocode"
          selectedValue={unlocode}
          onSelect={({ value }) => onSelect(null, {value,name:"unlocode"})}
          onBlur={({value})=>{
              if(!value){
                onSelect(null, {value,name:"unlocode"})
              }
          }}
          
        />
             
          </Grid.Column>
        </Grid.Row>
        
  )
})

